export default "__VITE_ASSET__BpTCdUx5__"